<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav [showSegments]="'log'"></sbnb-gx-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="!mb-0">{{ type.label }}</h2>
      </sbnb-page-header>
      <h2>{{ type.label }}</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'gx-logs'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        fxFlex
        [componentName]="type.filterKey"
        [hideSaveSegment]="true"
        [defaultFilters]="segmentFilterDefaults"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
      <sbnb-search-bar
        *ngIf="type.type !== 'questions'"
        fxFlex="300px"
        fxFlex.lt-md
        placeholderText="Guest name or confirmation code..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
    </div>

    <div *ngIf="loading" class="table__no-items">Loading logs...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="!logs || logs?.length === 0"
        icon="log"
        text="No logs found matching these filters"></sbnb-no-items>

      <div *ngIf="logs && logs.length > 0" class="rules__container">
        <div
          *ngFor="let log of logs"
          [routerLink]="[type.editUrl + (log.review_id || log.randomkey || log.id)]"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="18px">
          <sbnb-log-send-status [log]="log"></sbnb-log-send-status>

          <div fxFlex fxHide.lt-md class="rule__title strong rule__title-{{ log.send_status }} ellipsis">
            <ng-container *ngIf="log.type !== 'answer'">{{ log.title }}</ng-container>
            <ng-container *ngIf="log.type === 'answer'">{{ generateQuestionTitle(log) }}</ng-container>
          </div>

          <div fxHide.lt-md fxFlex class="rule__when" fxLayoutAlign="start center" fxLayoutGap="16px">
            <span class="text__small" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
              <img
                *ngIf="log.guest.picture"
                [src]="log.guest.picture"
                fxFlex="24px"
                class="log__picture"
                alt="{{ log.guest.name }}" />
              <div *ngIf="!log.guest.picture && log.guest.name" fxFlex="24px" class="log__picture-placeholder"></div>
              <strong>{{ log.guest.name }}</strong>
            </span>
          </div>

          <div fxHide.gt-sm class="rule__title ellipsis cera-heading" fxFlex>
            {{ log.title }}
            <br />
            <span class="text__small mobile__event-short">{{ log.guest.name }}</span>
          </div>

          <div fxHide.lt-md fxFlex *ngIf="log.property" fxLayoutAlign="start center" fxLayoutGap="16px">
            <img *ngIf="log.property?.picture" fxFlex="24px" [src]="log.property?.picture" class="property__image" />
            <span class="text__small ellipsis">{{ log.property?.name }}</span>
          </div>

          <span
            class="text__xsmall"
            style="text-align: right"
            fxFlex="140px"
            [matTooltip]="
              log.sent_at_tooltip || log.cancelled_at_tooltip || log.scheduled_for_tooltip || log.created_at_tooltip
            "
            fxHide.lt-md>
            {{ log.sent_at_label || log.cancelled_at_label || log.scheduled_for_label || log.created_at_label }}
          </span>

          <a [routerLink]="[type.editUrl + (log.review_id || log.randomkey || log.id)]">
            <button fxHide.lt-md mat-flat-button class="button__secondary button__small" fxFlex="80px">
              {{ log.send_status === 'sent' ? 'Details' : '' }}
              {{ log.send_status === 'cancelled' ? 'Details' : '' }}
              {{ log.send_status === 'pending' ? 'Edit' : '' }}
              {{ log.send_status === 'scheduled' ? 'Edit' : '' }}
              {{ log.send_status === 'failed' ? 'Details' : '' }}
              {{ log.send_status === 'prepared' ? 'Details' : '' }}
              {{ log.send_status === 'detected' ? 'Details' : '' }}
            </button>
          </a>
        </div>
      </div>
    </ng-container>

    <sbnb-pagination
      *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav [showSegments]="'log'"></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
